import * as config from '@/config/config.json';
import * as calculatorConfig from '@/config/base-config.json';
import { generateSliderSteps } from '@/utils/generateSliderSteps';

export const OTHERS_MORTGAGE_LOAN_LABEL = {
  Loan: 'Loan',
  LoanAmount: 'Loan Amount',
  InterestRate: 'Interest Rate',
  LoanFirstRepayment: 'Loan First Repayment',
  LoanTenureYears: 'Loan Tenure (Years)',
  InterestAndPrincipalChart: 'Interest & Principal Chart',
  FinancialBreakdown: 'Financial Breakdown',
  TotalPaid: 'Total Paid',
  TotalPrincipalPaid: 'Total Principal Paid',
  TotalInterestPaid: 'Total Interest Paid',
  ShowLess: 'Show less',
  ShowAll: 'Show all',
  PaymentMonth: 'Payment Month',
  MonthlyInstalment: 'Monthly Instalment',
  MonthlyInterest: 'Monthly Interest',
  MonthlyPrincipal: 'Monthly Principal',
  LoanBalance: 'Loan Balance',
  NoDataForRemainingTerms: 'No data for Remaining Terms',
};

const maxLoanTenure = Math.max(
  config.max_loan_tenure_in_years.hdb.bank_loan.upto_65_financing_year,
  config.max_loan_tenure_in_years.hdb.bank_loan.upto_75_financing_year,
  config.max_loan_tenure_in_years.hdb.hdb_loan,
  config.max_loan_tenure_in_years.ec.upto_65_financing_year,
  config.max_loan_tenure_in_years.ec.upto_75_financing_year,
  config.max_loan_tenure_in_years.commercial_industrial,
  config.max_loan_tenure_in_years.private_residential.upto_65_financing_year,
  config.max_loan_tenure_in_years.private_residential.upto_75_financing_year,
);

const maxInterestRate = Math.max(
  calculatorConfig.mortgage_interest_rate.commercial_industrial.max,
  calculatorConfig.mortgage_interest_rate.private_resale.max,
);

export const LOAN_TENURE = {
  MIN: 1,
  LABEL_INPUTS: generateSliderSteps(1, maxLoanTenure, 10),
  MAX: maxLoanTenure,
  STEP: 1,
  DEFAULT: config.max_loan_tenure_in_years.private_residential.upto_65_financing_year,
};

export const INTEREST_RATE = {
  LABEL_INPUTS: generateSliderSteps(0, maxInterestRate, 1),
  DEFAULT: calculatorConfig.mortgage_interest_rate.private_resale.default,
  MAX: maxInterestRate,
  STEP: 0.01,
};

export enum DisplayFormat {
  REMAINING = 'Remaining Terms',
  FULL = 'Full Terms',
}

export enum FinancialBreakdownDisplayFormat {
  ACCUMULATIVE = 'Accumulative',
  MONTHLY = 'Monthly',
}

export const DISPLAY_FORMAT = [DisplayFormat.REMAINING, DisplayFormat.FULL];

export const FINANCIAL_BREAKDOWN_DISPLAY_FORMAT = [
  FinancialBreakdownDisplayFormat.MONTHLY,
  FinancialBreakdownDisplayFormat.ACCUMULATIVE,
];

export const LIST_LABEL = [
  {
    name: OTHERS_MORTGAGE_LOAN_LABEL.TotalPaid,
    color: '#8884d8',
  },
  {
    name: OTHERS_MORTGAGE_LOAN_LABEL.TotalPrincipalPaid,
    color: '#82ca9d',
  },
  {
    name: OTHERS_MORTGAGE_LOAN_LABEL.TotalInterestPaid,
    color: '#ff4d4f',
  },
];
